import { StatoNotaEnum } from "../enum/stato-nota-enum";

import { TipoNotaLiquidazioneEnum } from "../enum/tipo-nota-liquidazione-enum";
import { AnagraficaBeneficiarioVO } from "./anagrafica-beneficiarioVO";
import { DecretoVO } from "./decretoVO";
import { DocumentoSpesaVO } from "./documento-spesaVO";
import { DocumentoVO } from "./documentoVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";
import { SettoreVO } from "./settoreVO";
import { UtenteVO } from "./utenteVO";
import { DatiPagamentoVO } from "./dati-pagamentoVO";
import { NotaDaSostituireVO } from "./nota-da-sostituireVO";

export class NotaLiquidazioneVO {
  id: string;
  oggetto: string;
  estensore: UtenteVO;
  settore: SettoreVO;
  decreto: DecretoVO;
  numeroFattura: string;
  riservata: boolean;
  tipologiaNota: TipoNotaLiquidazioneEnum;
  anagraficheBeneficiarie: AnagraficaBeneficiarioVO[];
  anagraficheBeneficiarieString: string;

  importoLordo: number; // calcolato nel mapper ma non aggiornato durante le operazioni di modifica, usato per export csv
  importoNetto: number; // calcolato nel mapper ma non aggiornato durante le operazioni di modifica, usato per export csv
  ritenute: number; // calcolato nel mapper ma non aggiornato durante le operazioni di modifica, usato per export csv

  responsabile: UtenteVO;
  stato: StatoNotaEnum;
  primario: DocumentoVO;
  contenutoNota: string;
  allegati: DocumentoVO[];
  //  visibilitaAtto: VisibilitaAttoDTO[];
  dataUltimaModifica: string;
  dataInserimento: string;
  dataConclusione: string;
  motivoStato: string;
  metadatiRepertorio: MetadatiRepertorioVO;
  datiPagamento: DatiPagamentoVO[];
  notaDaSostituire: NotaDaSostituireVO;
  settoreFirmatario: SettoreVO;
  presaInCarico: UtenteVO;
  cloneRitirata: boolean;
}
